import { useCallback, useState, useEffect, useRef } from "react";
import Logo from "../../../images/RK-Logo.png";
import { XMarkIcon } from '@heroicons/react/24/outline'
import { Bars3Icon } from '@heroicons/react/24/outline'
import { urlForImage } from '~/lib/sanity.image';
import Image from 'next/image';
import Link from 'next/link';

export default function StickyNavbar({siteConfig}) {  
  if (
    typeof window !== 'undefined' &&
    process.env.NEXT_PUBLIC_DEBUG_RENDER === 'true'
  ) {
    // eslint-disable-next-line no-console
    console.log('[render] StickyNavbar')
  }
  const navbar = useRef(null);
  const [lastScrollPosition, setLastScrollPosition] = useState(0);
  const [openNav, setOpenNav] = useState(false);

  const onScroll = useCallback(event => {
    const { scrollY } = window;     
    if(!openNav && navbar.current){
      if (scrollY <= 0) {
        navbar.current.style.position = 'sticky'
      } else {
        navbar.current.style.position = 'fixed'
        if (scrollY > lastScrollPosition) {
          navbar.current.style.top = '-100%'
        } else if (scrollY < lastScrollPosition) {
          navbar.current.style.top = 0
        }
      }
      setLastScrollPosition(scrollY)
    }    
  }, [lastScrollPosition, openNav]);  

  useEffect(() => {
    //add eventlistener to window
    window.addEventListener("scroll", onScroll, { passive: true });
    // remove event on unmount to prevent a memory leak with the cleanup
    return () => {
      window.removeEventListener("scroll", onScroll, { passive: true });
    }
  }, [onScroll]);
 
  useEffect(() => {
    window.addEventListener(
      "resize",
      () => window.innerWidth >= 960 && setOpenNav(false),
    );
  }, []);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      navbar.current.style.position = 'sticky'
      navbar.current.style.top = 0
    }, 2000);

    // Cleanup function to clear the timeout if the component unmounts
    return () => clearTimeout(timeoutId);
  }, []); // Empty dependency array ensures the effect runs only once

  function createNavigations(navObject) {
    const navigation = []
    if(navObject){
      navObject.items.map((navItem) => {
        let target = '_self'
        let href = ''
        if(navItem.navigationItemUrl.externalUrl){
          href = navItem.navigationItemUrl.externalUrl
          target = "_blank"
        }else {
          href = '/' + navItem.navigationItemUrl.internalLink.slug.current
        }
  
        let navI = {
          name: navItem.text,
          href: href,
          target: target,
          key: navItem._key
        }
        navigation.push(navI)
      })
    }

    return (
      <ul className="mt-2 mb-4 flex flex-col gap-2 lg:mb-0 lg:mt-0 lg:flex-row lg:items-center lg:justify-evenly lg:gap-6 text-black">      
        {navigation.map((item) => (
          <li key={item.name}>
            <a href={item.href} target={item.target} className="flex items-center justify-center font-borna text-black px-3 py-2 text-xl lg:text-2xl font-light uppercase md:text-left text-center ml-4 md:ml-0">
            {item.name}
            </a>
          </li>
        ))}      
      </ul>
    );
  }

  const navList = createNavigations(siteConfig.mainNav)
   
  return (
    <nav ref={navbar} className=" shadow-none navbar max-w-8xl w-full mx-auto bg-background rounded-none px-10 pb-2 pt-4 lg:py-4">
      <div className="flex items-center justify-between">
        <Link href="/" className="cursor-pointer font-medium">
          <Image 
            src={siteConfig.logo ? urlForImage(siteConfig.logo).url() : Logo} 
            alt={siteConfig ? siteConfig : 'RK Timber'} 
            width={0}
            height={0}
            sizes="100vw"
            style={{ width: '100%', height: 'auto', minWidth: '60px' }}  />
        </Link>
        <div className="w-full">
          <div className="mr-4 hidden lg:block">{navList}</div>          
        </div>
        <div className=" h-12 w-12">
        <button
          type="button"
          className="h-12 w-12 py-0 text-black hover:bg-transparent focus:bg-transparent active:bg-transparent lg:hidden"
          onClick={() => setOpenNav(!openNav)}
        >
            {openNav ? (
              <XMarkIcon className="block h-12 w-12 text-black" aria-hidden="true" />
            ) : (
              <Bars3Icon className="block h-12 w-12 text-black" aria-hidden="true" />
            )}
          </button>
        </div>
      </div>
      {openNav ? (
        <div className="block lg:hidden">{navList}</div>
      ) : null}
    </nav>      
  );
}